// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2UkqL","content":"styles_content__1iMYg","checkbox":"styles_checkbox__BXs4W","checkboxLabel":"styles_checkboxLabel__2q9RH"};